export const formatVNCurrency = (currency) =>
  new Intl.NumberFormat("vi-VN", { style: "currency", currency: "VND" }).format(
    currency
  );

export const getCurrentYear = new Date().getFullYear();
